import "bootstrap/dist/css/bootstrap.min.css";
import "./App/Assets/css/General.css";
import "./App/Assets/css/loader.css";
import "./App/Assets/css/style.scss";
import ConnectionLostImg from "./App/Assets/img/connection-lost.png";
import UpdateVersionImg from "./App/Assets/img/illustration-refresh.jpg";
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "connected-react-router";
import CacheBuster from "./CacheBuster";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import reducers from "./redux/reducers";
import sagas from "./redux/sagas";
import App from "./App/index";

const getSubdomain = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost") return "appdemo";
  return hostname.split(".")[0];
};

const getApiUrl = () => {
  const subdomain = getSubdomain();
  let modifiedSubdomain = subdomain?.includes("app")
    ? subdomain.replace("app", "")
    : subdomain;
  return `https://api${modifiedSubdomain}.gungunerp.in`;
};

axios.defaults.baseURL = getApiUrl();
axios.defaults.headers.common.Authorization = `JWT ${localStorage.getItem(
  "token"
)}`;
axios.defaults.headers.post["Content-Type"] = "application/json";

// middlewared
const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middlewares = [thunk, sagaMiddleware, routeMiddleware];
const store = createStore(
  reducers(history),
  compose(applyMiddleware(...middlewares))
);
sagaMiddleware.run(sagas);
ReactDOM.render(
  <CacheBuster>
    {({ loading, isLatestVersion, refreshCacheAndReload }) => {
      if (!loading && !isLatestVersion) {
        return (
          <div className="container">
            <div className="text-center h-100">
              <div
                style={{
                  backgroundImage: `url(${UpdateVersionImg})`,
                  height: 500,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              ></div>
              <button
                className="th-btn-primary px-3 py-1 my-3"
                onClick={() => {
                  refreshCacheAndReload();
                }}
              >
                Update Version
              </button>
            </div>
          </div>
        );
      }

      if (navigator.onLine) {
        return (
          <Provider store={store}>
            <App history={history} />
          </Provider>
        );
      } else {
        return (
          <div className="container">
            <div className="text-center h-100">
              <div
                style={{
                  backgroundImage: `url(${ConnectionLostImg})`,
                  height: 500,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              ></div>
              <div className="px-3 py-1 th-14">
                Pull down to refresh{" "}
                <i className="fa fa-angle-double-down" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        );
      }
    }}
  </CacheBuster>,

  document.getElementById("root")
);
serviceWorker.register();
export { store, history };
